import { useContext, useState, useEffect } from 'react';
import { CompareSettings } from './CompareSettings';
import Container from '@/components/layout/Container';
import Image from 'next/image';

export default function CompareLayers({
  block,
  entryUid,
  onDesktop,
  position
}) {
  const compareSettings = useContext(CompareSettings);
  const { compare_layers } = block;
  const [visibleLayers, setVisibleLayers] = useState([]);

  useEffect(() => {
    const tempArr = [];
    if (onDesktop) {
      compareSettings.desktopSelectors.forEach((selected) => {
        const matchingProduct = compare_layers.products[selected.index];
        tempArr.push(matchingProduct);
      });
    } else {
      compareSettings.mobileSelectors.forEach((selected) => {
        const matchingProduct = compare_layers.products[selected.index];
        tempArr.push(matchingProduct);
      });
    }

    setVisibleLayers(tempArr);
  }, [compareSettings, onDesktop, compare_layers]);

  return (
    <section
      id={entryUid + '_' + position}
      data-name="compare-products-cards"
      className="pt-[24px] pb-[24px] lg:pt-[34px] lg:pb-[34px]"
    >
      <Container fullPage={false}>
        <div
          className={`${onDesktop ? 'preheading-r' : 'preheading-s'} pb-2 pl-3`}
        >
          {compare_layers.row_title}
        </div>
        <div className="grid grid-cols-2 gap-x-[16px] sm:gap-x-[24px] lg:grid-cols-3 lg:gap-x-[32px]">
          {visibleLayers.map((product, index) => {
            return (
              <div
                key={index}
                className="border-dawn-grey-80 mb-5 w-full border-t-2 lg:mb-10"
              >
                <div className="flex h-full flex-row pt-5 lg:pt-10">
                  <Image
                    src={product.image.url}
                    width="379"
                    height="180"
                    alt={product.image.title.replace(/\.[^/.]+$/, '')}
                    sizes="(min-width: 1536px) 379px, (min-width: 1024px) 335px,(min-width: 1024px) 270px, 270px"
                    className="self-end"
                  />
                </div>
              </div>
            );
          })}
          {visibleLayers.map((product, index) => {
            return (
              <div key={index} className="">
                {product.layers.map((layer, index) => {
                  return (
                    <div
                      key={index}
                      className={`${index + 1 !== product.layers.length ? 'mb-6' : ''}`}
                    >
                      <div className={`flex pb-1`}>
                        <span className={`pr-1 ${onDesktop ? 'sh11' : 'sh12'}`}>
                          {index + 1}.
                        </span>
                        <div>
                          <div
                            className={`pb-1 lg:pb-2 ${onDesktop ? 'sh11' : 'sh12'}`}
                          >
                            {layer.layer_title}
                          </div>
                          <div
                            className={`flex ${onDesktop ? 'body-r' : 'body-s'}`}
                          >
                            {layer.layer_description}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
